/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { SpyLocation } from './location_mock';
export { MockLocationStrategy } from './mock_location_strategy';
//# sourceMappingURL=testing.js.map